export default {
  default: () => import("/app/src/layouts/default.vue")
}